export const applyDiscount = (price: number, discountPercent: number): string => {
  const discountAmount = price * (discountPercent / 100);
  return (price - discountAmount).toFixed(2);
};
